var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_4657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5959 5.51961L10.1676 8.94785L6.73937 5.51961L5.85547 6.40347L9.28375 9.83172L5.85547 13.26L6.73937 14.1439L10.1676 10.7156L13.5959 14.1439L14.4798 13.26L11.0515 9.83172L14.4798 6.40347L13.5959 5.51961Z",
    fill: "#A7ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6292 3.37086C14.871 1.6127 12.4864 0.624977 10 0.624977C7.51361 0.624977 5.12904 1.6127 3.37088 3.37086C1.61272 5.12901 0.625 7.51359 0.625 10C0.625 12.4864 1.61272 14.871 3.37088 16.6291C5.12904 18.3873 7.51361 19.375 10 19.375C12.4864 19.375 14.871 18.3873 16.6292 16.6291C18.3873 14.871 19.375 12.4864 19.375 10C19.375 7.51359 18.3873 5.12901 16.6292 3.37086ZM10 18.125C5.5199 18.125 1.87502 14.4801 1.87502 10C1.87502 5.51988 5.5199 1.875 10 1.875C14.4801 1.875 18.125 5.51988 18.125 10C18.125 14.4801 14.4801 18.125 10 18.125Z",
    fill: "#A7ADB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_4657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.f214bfebfa8503c81efa0d22f0354259.svg";
export { ForwardRef as ReactComponent };